import React from 'react';

export const InfluenceDisplay = ({ balance, showLabel = true, size = 'md' }) => {
  const sizes = {
    sm: 'text-sm px-2 py-1',
    md: 'text-base px-3 py-1.5',
    lg: 'text-lg px-4 py-2',
  };

  return (
    <div className={`inline-flex items-center bg-amber-100 text-amber-800 rounded-lg ${sizes[size]}`}>
      <svg className="w-4 h-4 mr-1.5" fill="currentColor" viewBox="0 0 20 20">
        <path d="M10 2a8 8 0 100 16 8 8 0 000-16zM8 12a1 1 0 102 0V9a1 1 0 10-2 0v3zm2-5a1 1 0 100-2 1 1 0 000 2z" />
      </svg>
      {showLabel && <span className="mr-1 font-medium">Influence:</span>}
      <span className="font-bold">{balance ?? 0}</span>
    </div>
  );
};

export const InfluenceChange = ({ amount, reason }) => {
  const isPositive = amount > 0;

  return (
    <span className={`
      inline-flex items-center text-sm font-medium
      ${isPositive ? 'text-green-600' : 'text-red-600'}
    `}>
      {isPositive ? '+' : ''}{amount}
      {reason && <span className="ml-1 text-gray-500">({reason})</span>}
    </span>
  );
};
